import React, { useEffect } from "react";
// import axios from 'axios';
import { connect } from "react-redux";
import { Actions as EMPLOYEEACTIONS } from "../../store/actions/employeeActions";
import { Actions as ORGANISATIONACTIONS } from "../../store/actions/organisationActions";
import { Actions as PERMISSIONACTIONS } from "../../store/actions/permissionActions";
import { Actions as WORKLOCATIONACTIONS } from "../../store/actions/workLocationActions";

import { PlusIcon, PrinterIcon, WrenchScrewdriverIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import LoadingContent from "../common/LoadingContent";
import ArchivedCompany from "../company-pages/ArchivedCompany";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import UpgradeRequired from "../company-pages/UpgradeRequired";
import AttachmentModal from "./AttachmentModal";
import CancelWorkLocationModal from "./CancelWorkLocationModal";
import CommentModal from "./CommentModal";
import TeamWorkLocation from "./TeamWorkLocation";

import { addMonths, format } from "date-fns";

const WorkLocation = ({
	org,
	employeeOptions,
	getWorkLocationSettings,
	employeesGetListWithSalary,
	setOpenModal,
	getOrganisationDetails,
	getMyPermissions,
	userWorkLocationPermissions,
	userSettingsPermissions,
	isDemo,
	includedInPlan,
	archivedStatus,
}) => {
	useEffect(() => {
		getWorkLocationSettings();
		employeesGetListWithSalary();
		getOrganisationDetails();
		getMyPermissions();
	}, []);

	if (archivedStatus == "Archived") return <ArchivedCompany />;
	if (!includedInPlan && !isDemo) return <UpgradeRequired />;
	if (userWorkLocationPermissions == "None") return <InvalidPermissions />;

	if (!org || !employeeOptions) return <LoadingContent />;

	return (
		<React.Fragment>
			<CommentModal />
			<AttachmentModal />
			<CancelWorkLocationModal />

			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Work Locations</h1>
						</div>

						<div className="pull-right">
							{userSettingsPermissions != "None" && (
								<Link
									className="btn btn-default pull-right"
									to="/organisation/settings/work-location"
									style={{ marginLeft: 10 }}
								>
									<WrenchScrewdriverIcon style={{ height: "1.5em", float: "left" }} />
								</Link>
							)}
							{userWorkLocationPermissions != "Read" && (
								<div
									className="btn btn-success pull-right"
									onClick={() => setOpenModal(true, null)}
								>
									<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
									<div style={{ float: "left" }}>Add Work Location Application</div>
								</div>
							)}

							<div
								className="btn btn-default pull-right"
								style={{ marginRight: 10 }}
								href="#"
								onClick={window.print}
							>
								<PrinterIcon style={{ height: "1.5em", float: "left" }} />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="mb-32">
				<TeamWorkLocation />
			</div>
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	const employeeOptions = state && state.employees && state.employees.employeeListWithSalary;
	return {
		tab: (state.workLocation && state.workLocation.tab) || "applications",
		org: state?.company?.settings?.org,
		isDemo: state?.company?.settings?.isDemo,
		workLocationReportUpdating: state.workLocation && state.workLocation.workLocationReportUpdating,
		employeeOptions,
		userWorkLocationPermissions: state?.permissions?.my?.permissions?.workLocations,
		includedInPlan: state.permissions?.plan?.workLocation,
		userSettingsPermissions: state?.permissions?.my?.permissions?.settings,
		archivedStatus: state?.company?.settings?.status,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getMyPermissions: () => dispatch(PERMISSIONACTIONS.getMyPermissions()),
	getWorkLocationSettings: () => dispatch(WORKLOCATIONACTIONS.getWorkLocationSettings()),
	employeesGetListWithSalary: () =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary({
				from: format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
				to: format(new Date(), "yyyy-12-31"),
			}),
		),

	setOpenModal: (status, workLocation) => dispatch(WORKLOCATIONACTIONS.setOpenModal(status, workLocation)),
	showWorkLocationBalanceReportModal: () => dispatch(WORKLOCATIONACTIONS.showWorkLocationBalanceReportModal(true)),
	workLocationTab: (tab) => dispatch(WORKLOCATIONACTIONS.workLocationTab(tab)),

	getOrganisationDetails: () => dispatch(ORGANISATIONACTIONS.getOrganisationDetails()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkLocation);
